// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sTaQg5v1fsl4uuC4vWV1{min-height:36px;padding:6px 12px;border-radius:5px;display:inline-flex;align-items:center}.sTaQg5v1fsl4uuC4vWV1>*{line-height:1.2;display:inline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "sTaQg5v1fsl4uuC4vWV1"
};
export default ___CSS_LOADER_EXPORT___;
